<template>
    <div style="background-color: white;height: 100%;">
        <div class="content">
            <div class="news-list">
                <Bread :breads="breads"></Bread>
                <div class="news-nav">
                    <div class="news-nav-list">
                        <template v-for="(item, index) in items">
                            <div class="news-nav-item" :class="{'active':active==index}"  @click="categoryClick(index)"  v-if="item.name != '最新发布'">
                                {{item.name}}
                            </div>
                        </template>
                    </div>
                    <div class="news-content">
                        <div class="news-content">
                            <div class="query-box form-inline">
                                <div class="form-group">
                                    <label for="key" class="control-label">关键词</label>

                                    <el-input
                                        v-model="keyword"
                                        clearable
                                        class="inline-input w-50"
                                        placeholder="输入关键词"
                                    />
                                </div>

                                <button type="button" class="btn btn-primary btn-search" style="background-color: #1EB38A;" @click="pageChange(1)">查询
                                </button>

                            </div>
                            <table class="table table-bordered" v-loading="loading">
                                <thead>
                                <tr>
                                    <td>标题</td>
                                    <td width="162px">时间</td>
                                </tr>
                                </thead>

                                <tbody v-if="items.length > 0 && items[active].content && items[active].content.list.length > 0">
                                <tr v-for="item in items[active].content.list" :key="item.id">
                                    <td><a href="javascript:void(0);" @click="gotoDetail(item.id)"
                                           v-html="matchKey(item.title)"></a></td>
                                    <td>{{ item.publishTime.substring(0, 10) }}</td>
                                </tr>
                                </tbody>
                                <tbody v-else style="min-height: 500px;">
                                <tr>
                                    <el-empty description="暂无数据" />
                                </tr>

                                </tbody>

                            </table>
                            <Pager class="i-pager" @pageChange="pageChange" :currentPage="currentPage"
                                   :totalPage="totalPage"></Pager>


                        </div>
                    </div>
                </div>

            </div>

<!--            <NewsList :breads="breads" :active="active" :categories="items" @itemClick="categoryClick">-->
<!--                <template v-slot:content>-->
<!--                    -->
<!--                </template>-->

<!--            </NewsList>-->
        </div>
    </div>

</template>

<script>
import NewsList from '../../components/common/NewsList'
import Pager from '../../components/common/Pager'
import VueDatepickerUi from 'vue-datepicker-ui'
import 'vue-datepicker-ui/lib/vuedatepickerui.css'
import {ref, onMounted, getCurrentInstance} from 'vue'
import {useRoute} from 'vue-router'
import qs from 'qs'
import Bread from "@/components/common/Bread.vue";

export default {
    name: "Platform",

    data() {
        return {
            date: [],
            currentPage: 1,
        }
    },
    components: {Bread, NewsList, Pager, Datepicker: VueDatepickerUi},
    setup() {
        const {proxy} = getCurrentInstance();
        const items = ref([]);
        const loading = ref(false);
        const route = useRoute();
        const id = ref('');
        const active = ref(0);
        const keyword = ref('');
        const keywordTypeVal = ref('');
        const restaurants = ref([
            {value: 'GDSTI文档', label: 'GDSTI文档',},
            {value: '论文报告', label: '论文报告',},
            {value: 'pdf', label: 'pdf',},
            {value: '国外参考', label: '国外参考',},
            {value: '指导建议', label: '指导建议',},
            {value: '规章制度', label: '规章制度',},
            {value: '政策法规', label: '政策法规',},
            {value: '标准规范', label: '标准规范',},
            {value: '指南方针', label: '指南方针',},
            {value: '调查汇编', label: '调查汇编',},
            {value: '图片', label: '图片',},
        ]);
        const date = ref([])
        const breads = ref([{
            text: '首页',
            path: '/zhaoqing/index',

        }]);

        const catalogType = ref([   //文章类别
            {id: 'WEB_ZHAOQING_TECHNOLOGY_POLICY', name: '科技政策'},
            {id: 'WEB_ZHAOQING_INFORMATION_RELEASE', name: '信息发布'},
            // {id: 'WEB_ZHUHAI_EQUIPMENT_SHARING', name: '设备共享'},
            // {id: 'WEB_ZHUHAI_FILLING_GUIDE', name: '填报指南'},
        ]);

        if (route.query.id) {
            id.value = route.query.id;
        }

        const queryCatalogTypes = ref('');
        if (route.query.catalogTypes) {
            queryCatalogTypes.value = route.query.catalogTypes;
        }


        const querySearch = (queryString, cb) => {
            const results = queryString
                ? restaurants.value.filter(createFilter(queryString))
                : restaurants.value
            // call callback function to return suggestions
            cb(results)
        }

        const createFilter = (queryString) => {
            return (restaurant) => {
                return (
                    restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
                )
            }
        }


        const handleSelect = (item) => {
            console.log(item)
        }


        function getCategories() {
            //左边分类
            //items.value = catalogType.value;
            if (queryCatalogTypes.value != '') {
                let catalogTypeArr = queryCatalogTypes.value.split(',');
                for (let queryCatalogType of catalogTypeArr) {
                    for (let item of catalogType.value) {
                        if (queryCatalogType == item.id) {
                            items.value.push(item);
                        }
                    }
                }
            } else {
                items.value = catalogType.value;
            }


            for (var i = 0; i < items.value.length; i++) {
                if (id.value == items.value[i].id) {
                    active.value = i;
                    breads.value.push({text: items.value[i].name})
                    proxy.getList(i);
                }
            }
        }


        onMounted(() => {
            getCategories();
        });

        return {loading, items, active, breads, keyword, date, id, keywordTypeVal, querySearch, handleSelect};
    },
    computed: {
        totalPage() {
            if (this.items.length > 0 && this.items[this.active].content) {
                return this.items[this.active].content.totalPage;
            } else {
                return 1;
            }
        }
    },
    methods: {
        categoryClick: function (index) {
            this.active = index;
            if (this.breads.length == 1) {
                this.breads.push({text: this.items[this.active].name})
            } else {
                this.breads[1].text = this.items[this.active].name;
            }
            this.currentPage = 1;
            this.getList(index);
        },
        gotoDetail(id) {
            let routeData = this.$router.resolve({path: '/zhuhai/zhuhaiNewsDetail', query: {id: id}});
            window.open(routeData.href, '_blank');

        },
        getList(index) {
            this.loading = true;
            const item = this.items[index];

            this.$http.post('/core/cms/a/articleContent/list', {
                typeCode: item.id, limit: 10, offset: (this.currentPage - 1) * 10,
                searchValue: this.keyword,
                apprStatus: '1,99',
                publishStatus: '1',
                timeField: 'publish_time',
            })
                .then(res => {
                    this.loading = false
                    if (res.data.state == 0) {
                        item.content = res.data.result;
                    }
                }).catch(err => {
                this.loading = false
            });
        },
        pageChange(page) {
            this.currentPage = page;
            this.getList(this.active);
        },
        matchKey(val) {
            if (this.keyword) {
                let keyword = this.keyword;
                let replaceReg = new RegExp(keyword, 'ig')
                let replaceString = `<span style="color: #E02020;">${keyword}</span>`
                return val.replace(replaceReg, replaceString);
            } else {
                return val;
            }
        }
    }
}
</script>

<style lang="less" scoped>
.i-pager {
    margin-top: 38px;
    margin-bottom: 27px;
}

.table td {
    font-family: SourceHanSansCN-Regular;
    font-size: 16px;
    color: rgba(0, 0, 0, 0.85);
}

.query-box {
    margin-bottom: 16px;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
}

#category {
    width: 100px;
}

#key {
    width: 171px;
}

#date {
    display: inline-block;
}

.btn-search {
    margin-left: 48px;
}

.news-content{

    width: 883px;
}
.news-nav{
    margin-top: 10px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}
.news-nav-list{
    display: inline-block;
    width: 283px;

    .news-nav-item{
        background: #F2F2F2;
        font-family: SourceHanSansCN-Regular;
        font-size: 18px;
        color: #242424;
        letter-spacing: 0;
        text-align: center;
        line-height: 48px;
        margin-bottom: 11px;
        cursor: pointer;
    }
    .news-nav-item:hover{
        background: #C3c3c3;
    }
    .active,.active:hover{
        color: #FFFFFF;
        background: #61CFAF;
    }
}
.nav-item{
    width: 283px;
    margin-bottom: 11px;
    font-family: SourceHanSansCN-Regular;
    font-size: 18px;
    color: #FFFFFF;
    letter-spacing: 0;
    text-align: center;
    line-height: 48px;
}

</style>

